// extracted by mini-css-extract-plugin
module.exports = {"mobile":"ImagesGallery_mobile__1Q_Sn","tablet":"ImagesGallery_tablet__1EKGL","desktop":"ImagesGallery_desktop__2_Qfd"};